import styled from 'styled-components';

export const ResetPasswordStyled = styled.div`
    .reset-password-content__title {
        margin-bottom: 24px;
    }
    .reset-password-content__password {
        margin-top: 48px;
        margin-bottom: 24px;
    }
    .reset-password-content__password-confirm {
        margin-bottom: 24px;
    }
    .reset-password-content__submit-button {
        margin-top: 48px;
    }
`;
